// The words a box action ends on. Pure, so the card and the repair session say the same thing.

import type { BoxItem, PullResult } from '../../Parts/Pulls/pullsApi';

type Named = { display_name: string | null; sku: string | null };

export const itemName = (i: Named): string => i.display_name || i.sku || 'item';

export const pulledForRnd = (r: PullResult, project: string): string =>
  `Pulled ${r.quantity} ${itemName(r.item)} for ${project}. ${r.item.quantity_remaining} left at ${r.from.name}.`;

export const pulledForScrap = (r: PullResult): string =>
  `Scrapped ${r.quantity} ${itemName(r.item)}. ${r.item.quantity_remaining} left at ${r.from.name}.`;

export const pulledForRepair = (r: PullResult, serial: string): string =>
  `${itemName(r.item)} × ${r.quantity} for ${serial}, from ${r.from.name}`;

export const threwOut = (item: BoxItem, quantity: number): string =>
  `Threw out ${quantity} ${itemName(item)}.`;

export const movedTo = (item: BoxItem, quantity: number, to: string): string =>
  `Moved ${quantity} ${itemName(item)} to ${to}.`;

export const boxEmptied = (barcode: string, count: number): string =>
  `${barcode} written off to zero, ${count} ${count === 1 ? 'item' : 'items'}.`;
